const assert = require('assert');
const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';
const NEW_VERSION = 'v4';

class OfferServiceConnector {
  constructor(configuration) {
    assert(configuration, 'configuration is required');
    this.httpClient = axios.create(configuration);
  }

  async list({ bookingChannelId }) {
    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/offers`, {
        params: {
          bookingChannelId,
        },
      });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  // Legacy method
  async listByEta({ longitude, latitude, lang }) {
    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/offersEta`, {
        params: {
          lang, longitude, latitude,
        },
      });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async offersList({
    lang,
    pickupLatitude,
    pickupLongitude,
    destinationLatitude,
    destinationLongitude,
    corporationId,
  }) {
    try {
      const { data } = await this.httpClient.get(`/${NEW_VERSION}/offersEta/standard`, {
        params: {
          lang,
          pickupLatitude,
          pickupLongitude,
          destinationLatitude,
          destinationLongitude,
          corporationId,
        },
      });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getById({ id, bookingChannelId }) {
    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/offers/${id}`, {
        params: {
          bookingChannelId,
        },
      });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  OfferServiceConnector,
};
